// Module
var code = `<div class="location-left">
  <h2 class="location-title">{{title}}</h2>
  <p class="location-subtitle">{{subtitle}}</p>
  <div class="location-image-wrap">
    <img alt="{{attrImageAlt}}" src="{{attrImageSrc}}" class="location-image" />
  </div>
</div>
<div class="location-map-wrap">
  <iframe src="{{attrMapSrc}}" class="location-map-iframe"></iframe>
</div>
`;
// Exports
module.exports = code;